// Рубильник игры (HQ-1570/HQ-1572, слово владельца 28.10): сервер выключает игру, убирая профиль приложения из списка
// игры, и отдаёт в config features.game: false / game.enabled: false. Тогда в Mini App игры нет нигде: ни вкладки, ни
// маршрутов /game и /world, ни игровых блоков матча, ни реакций; «Кто победит?» — опросом блока who_wins.
import type { AppConfig } from './api/types';

/** Игра выключена: конфиг получен И (features.game === false ИЛИ game.enabled === false). Конфига нет — не выключена
 *  (решение ждёт конфига: маршруты игры показывают загрузку, мир без world_path и так закрыт). */
export function gameOff(config: AppConfig | undefined): boolean {
  if (!config) return false;
  return config.features?.game === false || config.game?.enabled === false;
}

/** Куда уводить с маршрута игры или мира (/game…, /world…): игра включена — null (маршрут как есть); выключена —
 *  вкладка «Матчи», нет такой вкладки — вкладка по умолчанию. */
export function gameRouteRedirect(config: AppConfig | undefined, tabKeys: readonly string[], defaultKey?: string): string | null {
  if (!gameOff(config)) return null;
  const key = tabKeys.includes('matches') ? 'matches' : defaultKey;
  return key ? `/tab/${key}` : '/';
}
